export const title = 'Please fill out the form below';
export const dataTitle = 'Data Information';
export const personalTitle = 'Your Information';
export const companyTitle = 'Company Information';

export const link = 'Request Data';
